import 'whatwg-fetch'
import 'core-js/features/promise'
import 'core-js/features/string/starts-with'
import 'core-js/features/string/ends-with'
import 'core-js/features/array/includes'
import 'core-js/features/array/every'
import 'core-js/features/array/some'
import 'core-js/features/array/find'
import 'core-js/features/symbol'
import 'core-js/features/map'
import 'core-js/features/symbol/iterator'
import 'core-js/features/array/from'
import 'core-js/features/array/flat'
import 'core-js/features/object/values'

// Safari padStart implementation is buggy: https://developer.apple.com/safari/technology-preview/release-notes/
// "Fixed a bug where String.prototype.padStart() and padEnd() would insert null in rare cases"
import padStart from 'core-js-pure/features/string/pad-start'
String.prototype.padStart = function (maxLength /*, fillString = ' ' */) { // eslint-disable-line no-extend-native
  return padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true)
}
